import { XMarkIcon } from '@heroicons/react/24/outline';

import { Badge } from '@/components/ui/catalyst/badge';
import { ReadDepartmentRecordsChannel } from '@/services/api/generated/policeDepartmentsService';

import { ChannelDetails } from './ChannelDetails';
import {
  getChannelIcon,
  getChannelTypeLabel,
} from './ChannelDisplayComponents';
import { formatContactValue } from './formatters';

interface ChannelDetailsModalProps {
  channel: ReadDepartmentRecordsChannel;
  onClose: () => void;
}

export const ChannelDetailsModal = ({
  channel,
  onClose,
}: ChannelDetailsModalProps) => {
  const Icon = getChannelIcon(channel);
  const typeLabel = getChannelTypeLabel(channel);
  const contactValue = formatContactValue(channel);
  const handleName = channel.handle?.name;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-2xl rounded-lg bg-white shadow-xl">
        {/* Header */}
        <div className="flex items-start gap-4 border-b border-gray-200 p-6">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 bg-gray-50">
            <Icon className="h-5 w-5 text-gray-600" />
          </div>
          <div className="flex-1">
            <div className="mb-2 flex items-center gap-2">
              <Badge color="zinc" className="text-xs">
                {typeLabel}
              </Badge>
            </div>
            {handleName && (
              <h2 className="text-lg font-semibold text-gray-900">
                {handleName}
              </h2>
            )}
            {contactValue && (
              <p className="mt-1 text-sm text-gray-600">{contactValue}</p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="max-h-[calc(100vh-12rem)] overflow-y-auto p-6">
          <ChannelDetails channel={channel} />
        </div>
      </div>
    </div>
  );
};
